module.exports = __webpack_public_path__ + "files/46661d6d65debc63884004fed6e37e5c.svg";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/arvo-bold-webfont.svg
// module id = 642
// module chunks = 60